import * as React from 'react';
import { Box } from '@mui/material';
import Header from "./components/Header";
import ContainerFluid from "./components/ContainerFluid";
import { ThemeProvider } from "./styles/theme/ThemeProvider"; //상태관리
import { BrowserRouter } from 'react-router-dom';

// function App() {
const App = (props) => {

  //SideBar
  const [DrawerOpen, setDrawerOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setDrawerOpen(!DrawerOpen);
  };

  return (
    <ThemeProvider>
      <Box className='common-layout'>
        <Header onDrawerToggle={handleDrawerToggle} />
        <BrowserRouter>
          <ContainerFluid
            open={DrawerOpen}
            onClose={handleDrawerToggle}
          />
        </BrowserRouter> 
      </Box>
    </ThemeProvider>
  );
};
export default App;